<template>
  <b-modal
    v-model="trigger"
    :centered="true"
    :no-close-on-backdrop="dontCloseWhenClickedOutside"
    :no-close-on-esc="dontCloseWhenEscapePressed"
    :hide-header-close="dontShowCloseIcon"
    :hide-footer="true"
    :hide-header="true"
    @cancel="eventCancel($event)"
    :size="'xl'"
  > 
    <div class="empanel-modal-close">
      <span v-if="isEdit" class="Modal-head-text">Edit Statutory Details</span>
      <p class>
        <img
          @click="closeContactModal()"
          class="cursor-pointer modal-close-button mt-n1"
          style="float:right"
          src="@/assets/images/close1.svg"
        />
      </p>
    </div>
    <div class="card contact-card" style="padding-bottom:20px;">
      <div class="row" style="padding:10px;background: #f7f7f7;margin: 0px;margin-bottom: 5px;"
      v-if="!$root.isInternational">
        <div class="col-2" :class="isTANPresent=='Y' ? 'disabled-field':''">
          <h6 class="">TAN Number</h6>
          <b-form-group label>
                    <b-form-radio-group
                      v-model="isTAN"
                      @change="checkRadioTan()"
                      :options="[
          { text: 'Yes', value: 'Y' },
          { text: 'No', value: 'N' }        ]"
                    ></b-form-radio-group>
                  </b-form-group>
                  </div>     
          <div class="col-3" v-if="isTAN=='Y'" :class="isTANPresent=='Y'">
                <w-text-input
                  :labelName="$t('Tan Number')"
                  @textInputChange="getTanNumber($event)"
                  validation="required|regex_alpha_tan|max:10|min:10"
                  :defaultValue="statForm.tan?statForm.tan:''"
                  :maxCharacter="'20'"
                  :placeholder="ABCD12345A"
                /><span style="font-size: 12px;color: rgb(152 152 152);
                position: absolute;top: 2px;left: 100px;">Ex: ABCD12345A</span>
                <p
                  class="mt-n2 font-weight-bold text-danger lato-regular"
                  v-if="tanDuplicate == true"
                >TAN Number is already used</p>
              </div>
              <div class="col-6">
              <div style="display:inline-block;">
                <FileUploader style="display: inline-block;"
                  :heading="isTAN=='Y'?'Attach TAN document':'Attach No TAN Declaration'" 
                  @fileInputChange="UploadDocument($event, 'tan')"
                />
                <ul style="list-style-type:disc;display: inline-block;">
                  <li style="max-width: 200px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
                    <a
                      @click="showAttachFile()"
                      href="#"
                      class="mt-n2"
                    >{{getFileName(statForm.tanDocId)}}</a>
                  </li>
                </ul>
                <!--span @click="removeAttachment(index)" style="padding: 25px;cursor:pointer;" 
                title="Remove Attachment">
                  <img style="height:25px" src="@/assets/delete_Icon.svg"/></span-->
              </div>
              </div>   
              </div>  
              <div v-if="isTANPresent=='Y'"
              style="color:red;padding-left:15px;">
              Note: TAN Already exists. Disabled fields can be changed. </div>        
              

<!-- vat number -->
      <div class="row" style="padding:10px;background: #f7f7f7;margin: 0px;margin-bottom: 5px;"
      v-if="$root.isInternational">   
        <div class="col-2" :class="isVATPresent=='Y' ? 'disabled-field':''">
          <h6 class="">VAT Number</h6>
          <b-form-group label>
                    <b-form-radio-group
                      v-model="isVAT"
                      @change="checkRadioVat()"
                      :options="[
          { text: 'Yes', value: 'Y' },
          { text: 'No', value: 'N' }        ]"
                    ></b-form-radio-group>
                  </b-form-group>
                  </div>     
          <div class="col-3" v-if="isVAT=='Y'" :class="isVATPresent=='Y'">
               <w-text-input
                  :labelName="$t('VAT Registration Number')"
                  @textInputChange="getVatNumber($event)"
                  validation="required|regex_alpha_numeric|max:20|min:5"
                  :defaultValue="statForm.vatRegNumber?statForm.vatRegNumber:''"
                  :maxCharacter="'60'"
                  :placeholder="''"
                /><span style="font-size: 12px;color: rgb(152 152 152);
                position: absolute;top: 2px;left: 100px;"></span>
                <p
                  class="mt-n2 font-weight-bold text-danger lato-regular"
                  v-if="vatDuplicate == true"
                >VAT Registration Number is already used</p>
              </div>
              <div class="col-6">
              <div style="display:inline-block;">
                <FileUploader style="display: inline-block;"
                  :heading="isVAT=='Y'?'Attach VAT document':'Attach No VAT Declaration'" 
                  @fileInputChange="UploadDocument($event, 'vat')"
                />
                <ul style="list-style-type:disc;display: inline-block;">
                  <li style="max-width: 200px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
                    <a
                      @click="showAttachFile()"
                      href="#"
                      class="mt-n2"
                    >{{getFileName(statForm.vatDocId)}}</a>
                  </li>
                </ul>
                <!--span @click="removeAttachment(index)" style="padding: 25px;cursor:pointer;" 
                title="Remove Attachment">
                  <img style="height:25px" src="@/assets/delete_Icon.svg"/></span-->
              </div>
              </div>
              </div>
              <div v-if="isVATPresent=='Y'"
              style="color:red;padding-left:15px;">
              Note: VAT Details Already exists. Disabled fields can be changed. </div> 
              

<!--aadhar number-->
              
      <div class="row" style="padding:10px;background: #f7f7f7;margin: 0px;margin-bottom: 5px;"
      v-if="!$root.isInternational && isAadharApplicable">   
        <div class="col-2" :class="isAadharPresent=='Y' ? 'disabled-field':''">
          <h6 class="">Aadhar Number</h6>
          <b-form-group label>
                    <b-form-radio-group
                      v-model="isAadhar"
                      @change="checkRadioAadhar()"
                      :options="[
          { text: 'Yes', value: 'Y' },
          { text: 'No', value: 'N' }        ]"
                    ></b-form-radio-group>
                  </b-form-group>
                  </div>     
          <div class="col-3" v-if="isAadhar=='Y'" :class="isAadharPresent=='Y'">
                <w-text-input
                  :labelName="$t('Aadhaar Number')"
                  @textInputChange="getAadhaarNumber($event)"
                  validation="required|regex_alpha_aadhaar|max:12|min:12"
                  :defaultValue="statForm.aadhar?statForm.aadhar:''"
                  :maxCharacter="'13'"
                  :placeholder="'12 digit number (Ex:123412341234)'"
                />
                <p
                  class="mt-n2 font-weight-bold text-danger lato-regular"
                  v-if="aadhaarDuplicate == true"
                >Aadhaar Number is already used</p>
              </div>
              <div class="col-6" >
              <div style="display:inline-block;">
                <FileUploader style="display: inline-block;"
                  :heading="isAadhar=='Y'?'Attach Aadhar document':'Attach No Aadhar Declaration'" 
                  @fileInputChange="UploadDocument($event, 'aadhar')"
                />
                <ul style="list-style-type:disc;display: inline-block;">
                  <li style="max-width: 200px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
                    <a
                      @click="showAttachFile()"
                      href="#"
                      class="mt-n2"
                    >{{getFileName(statForm.aadharDocId)}}</a>
                  </li>
                </ul>
                <!--span @click="removeAttachment(index)" style="padding: 25px;cursor:pointer;" 
                title="Remove Attachment">
                  <img style="height:25px" src="@/assets/delete_Icon.svg"/></span-->
              </div>
              </div> 
              </div>  
               <div v-if="isAadharPresent=='Y'"
              style="color:red;padding-left:15px;">
              Note: Aadhaar Details Already exists. Disabled fields can be changed. </div>           
              

<!--msme-->
              
      <div class="row" style="padding:10px;background: #f7f7f7;margin: 0px;margin-bottom: 5px;"
      v-if="!$root.isInternational">   
        <div class="col-2" :class="isMSMEPresent=='Y' ? 'disabled-field':''">
          <h6 class="">MSME Number</h6>
          <b-form-group label>
                    <b-form-radio-group
                      v-model="isMSME"
                      @change="checkRadioMSME()"
                      :options="[
          { text: 'Yes', value: 'Y' },
          { text: 'No', value: 'N' }]"
                    ></b-form-radio-group>
                  </b-form-group>
                  </div>     
          
              <div class="col-2" v-if="isMSME=='Y'">
                <label for="msmeType">MSME Type</label>
                   <select name="msme" id="msme" class="form-control"
                   v-model="statForm.msmeType">
                      <option value>--Select--</option>
                      <option value="MICRO">Micro</option>
                      <option value="SMALL">Small</option>
                      <option value="MEDIUM">Medium</option>
                    </select>
              </div>
              <div class="col-2" v-if="isMSME=='Y'">
                <Datepicker1
                  :inputLabel="'Effective From'"
                  :inputPlaceholder="$t('select date')"
                  :errorMessage="''"
                  :dateRange="''"
                  :msmeDateociker="true"
                  :disabled="''"
                  :diableddatefrom="msmeDisabledDate"
                  @inputChange="getSelectedMSMEDate($event)"
                  :v-validate="'required'"
                  :defaultValue="statForm.msmeEffectiveFrom?statForm.msmeEffectiveFrom:''"
                />
                <span></span>
              </div>
              <div class="col-3" v-if="isMSME=='Y'" :class="isMSMEPresent=='Y'">
                <w-text-input
                  :labelName="$t('MSME Number')"
                  @textInputChange="getMsmeNumber($event)"
                  validation="regex_msme"
                  :defaultValue="statForm.msmeNumber?statForm.msmeNumber:''"
                  :maxCharacter="'20'"
                  :disabled="false"
                />
                <p
                  class="mt-n2 font-weight-bold text-danger lato-regular"
                  v-if="msmeDuplicate== true"
                >MSME Number is already used</p>
              </div>
              <div class="col-3" v-if="isMSME=='Y'">
                <label for="msmeClassificationYear">MSME Classification Year</label>
                   <select name="msme" id="msme" class="form-control"
                           v-model="statForm.msmeClassificationYear">
                      <option value>--Select--</option>
                      <option v-for="year in msmeYearRange" :value="year">{{ year }}</option>
                    </select>
              </div>
              <div class="col-6" v-if="isMSME=='Y'">
              <div style="display:inline-block;">
                <FileUploader style="display: inline-block;"
                  :heading="'Attach MSME document'" 
                  @fileInputChange="UploadDocument($event, 'msme')"
                />
                <ul style="list-style-type:disc;display: inline-block;">
                  <li style="max-width: 200px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
                    <a
                      @click="showAttachFile()"
                      href="#"
                      class="mt-n2"
                    >{{getFileName(statForm.msmeDocId)}}</a>
                  </li>
                </ul>
                <!--span @click="removeAttachment(index)" style="padding: 25px;cursor:pointer;" 
                title="Remove Attachment">
                  <img style="height:25px" src="@/assets/delete_Icon.svg"/></span-->
              </div>
              </div>                    
              </div>
              <div v-if="isMSMEPresent=='Y'"
              style="color:red;padding-left:15px;">
              Note: MSME Details Already exists. Disabled fields can be changed. 
            </div> 


      <div class="row mt-3 mr-1">
      <!-- v-if="(!$root.isInternational && (isMSMEPresent!='Y' || isTANPresent!='Y' || isAadharPresent!='Y')) || 
      ($root.isInternational)">  -->
        <!-- <div class="col-8"></div> -->
        <div class="col">
          <!--b-button
            v-if="!isEdit"
            class="ml-2 button-class"
            @click="saveAddress(isEdit)"
          >Save</b-button-->
          <b-button
            v-if="isEdit"
            class="ml-2 button-class"
            @click="saveStatutory(isEdit)"
          >Update</b-button>
        </div>
      </div>
    </div>
    <w-loadingSpinner :loadSpinner="loading" />
  </b-modal>
</template>
<script>
import TextInput from "./TextInput";

import Datepicker1 from "../widgets/DatePicker";
import DropDown from "../widgets/DropDown";
import FileUploader from "../widgets/FileUploader";
import loadingSpinner from "../widgets/LoadingSpinner";
import { OnBoardingServices } from "../services/onBoardingService";
import { PartnerService } from "../services/partnerService";
// import VeeValidate from "vee-validate";
const OnBoardingService = new OnBoardingServices();
const partnerService = new PartnerService();
import { RegistrationService } from "../services/RegistrationService.js";
const RegisterService = new RegistrationService();

export default {
  components: {
    "w-text-input": TextInput,
    "w-dropdown": DropDown,
    "w-loadingSpinner": loadingSpinner,
    FileUploader,
    Datepicker1
  },
  props: [
    "trigger",
    "dontCloseWhenClickedOutside",
    "dontShowCloseIcon",
    "dontCloseWhenEscapePressed",
    "editStatutory",
    "isEdit",
    "categoryCode",
    "partnerId",
    "userId",
    "isAadharApplicable",
    "currentCompanyCode"
  ], 
  created() {
    this.getPartnerInfo();
    this.generateMSMEYearRange();
    this.statForm = {
          "aadhar": null,
          "aadharDocId": null,
          "aadharSiteUrl": "",
          "categoryCode": null,
          "companyCode": null,
          "msmeDocId": null,
          "msmeNumber": null,
          "msmeSiteUrl": "",
          "msmeType": null,
          "msmeClassificationYear": null,
          "partnerId": null,
          "remarks": "",
          "tan": null,
          "tanDocId": null,
          "tanSiteUrl": "",
          "userId": null,
          "vatDocId": null,
          "vatRegNumber": null,
          "vatSiteUrl": "",
          "msmeEffectiveFrom": ""
          };
    
    if(this.editStatutory.tanNumber){
      this.isTAN = 'Y'
      this.isTANPresent = 'Y'
    }if(this.editStatutory.vatNumber){
      this.isVAT = 'Y'
      this.isVATPresent = 'Y'
    }if(this.editStatutory.aadhaarNumber){
      this.isAadhar = 'Y'
      this.isAadharPresent = 'Y'
    } if(this.editStatutory.msmedNumber){
      this.isMSME = 'Y'
      this.isMSMEPresent = 'Y'
    } 
    this.isMSME = this.editStatutory.isMsme
    this.statForm.categoryCode = this.categoryCode
    this.statForm.companyCode = this.currentCompanyCode
    this.statForm.userId = this.userId
    this.statForm.partnerId= this.partnerId
    this.statForm.remarks = "Statutory update saved"
    if (this.isEdit) {
      this.statForm.tan = this.editStatutory.tanNumber
      this.statForm.tanDocId = this.editStatutory.tanDocumentId;
      this.statForm.tanSiteUrl = this.editStatutory.tanSiteUrl;
      this.statForm.vatRegNumber = this.editStatutory.vatNumber;
      this.statForm.vatDocId = this.editStatutory.vatDocumentId;
      this.statForm.vatSiteUrl = this.editStatutory.vatSiteUrl;
      this.statForm.aadhar = this.editStatutory.aadhaarNumber;
      this.statForm.aadharDocId = this.editStatutory.aadhaarDocumentId;
      this.statForm.aadharSiteUrl = this.editStatutory.aadharSiteUrl;
      this.statForm.msmeNumber = this.editStatutory.msmedNumber;
      this.statForm.msmeDocId = this.editStatutory.msmeDocId;
      this.statForm.msmeSiteUrl = this.editStatutory.msmeSiteUrl;
      this.statForm.msmeType= this.editStatutory.msmeType;
      this.statForm.msmeClassificationYear= this.editStatutory.msmeClassificationYear;
      this.statForm.msmeEffectiveFrom= this.editStatutory.certificateEffectiveFrom;
    }
  },
  computed() {
    console.log(this.contact);
  },
  data() {
    return { 
      msmeDisabledDate: new Date(2006, 9, 1), 
      currentYear: new Date().getFullYear(),
      msmeYearRange: [],   
      isTAN:'N',
      isAadhar:'N',
      isVAT:'N',
      isMSME:'N',
      isTANPresent:'N',
      isAadharPresent:'N',
      isVATPresent:'N',
      isMSMEPresent:'N',
      tanDuplicate:false,
      vatDuplicate:false,
      msmeDuplicate:false,
      aadhaarDuplicate:false,
      statForm: {
          "aadhar": null,
          "aadharDocId": null,
          "aadharSiteUrl": "",
          "categoryCode": null,
          "companyCode": null,
          "msmeDocId": null,
          "msmeNumber": null,
          "msmeSiteUrl": "",
          "msmeType": null,
          "msmeClassificationYear": null,
          "partnerId": null,
          "remarks": null,
          "tan": null,
          "tanDocId": null,
          "tanSiteUrl": "",
          "userId": null,
          "vatDocId": null,
          "vatRegNumber": null,
          "vatSiteUrl": ""
          },
      companycode: "",
      categorycode: "",
      loading: false
    };
  },
  methods: {    
    
    getSelectedMSMEDate(event) {
      // this.selectedMSMEDateRange = event;
      this.statForm.msmeEffectiveFrom = event;
      this.statForm.certificateEffectiveUpto = null;
    },
    generateMSMEYearRange() {
        const startYear = 2007;
        const endYear = this.currentYear;
        for (let year = startYear; year <= endYear; year++) {
            this.msmeYearRange.push(`${year}-${year + 1}`);
        }
    },
    checkRadioTan() {
      //this.statForm.tanDocId = null;
      this.statForm.tan = null;
    },
    checkRadioVat() {
      //this.statForm.vatDocId = null;
      this.statForm.vatRegNumber = null;
    },
    checkRadioAadhaar() {
      //this.statForm.aadharDocId = null;
      this.statForm.aadhar = null;
    },
    checkRadioMSME() {
      this.statForm.msmeNumber = null;
      this.statForm.msmeType = null;
      this.statForm.msmeClassificationYear = null;
      //this.statForm.msmeDocId= null;
      this.statForm.certificateEffectiveFrom= null;
    },
    getTanNumber(event) { 
      this.statForm.tan = event.toUpperCase();
      if (event.length > 9) {
        OnBoardingService.checkTANNumber(event).then(resp => {
          if (resp.failureMessage == "Not Available") {
            this.tanDuplicate = true;
          }
        });
      } else {
        this.tanDuplicate = false;
      }
    },       
    getVatNumber(event) {
      this.statForm.vatRegNumber = event.toUpperCase();
      if (event.length > 4) {
        OnBoardingService.checkVatNumber(event, this.companyCode).then(resp => {
          if (resp.failureMessage == "Not Available") {
            this.vatDuplicate = true;
          } else {
            this.vatDuplicate = false;
          }
        });
      } else {
        this.vatDuplicate = false;
      }
    },  
    getAadhaarNumber(event) {
      this.statForm.aadhar= event.toUpperCase();
      if (event.length > 11) {
        OnBoardingService.checkAadhaarNumber(event, this.companyCode).then(resp => {
          if (resp.failureMessage == "Not Available") {
            this.aadhaarDuplicate = true;
          }
        });
      } else {
        this.aadhaarDuplicate = false;
      }
    },   
    getMsmeNumber(event) {
      this.statForm.msmeNumber = event.toUpperCase();
      if (event.length > 11) {
        OnBoardingService.checkMSMENumber(event, this.companyCode).then(
          resp => {
            if (resp.failureMessage == "Not Available") {
              this.msmeDuplicate = true;
            }
          }
        );
      } else {
        this.msmeDuplicate = false;
      }
    },
    UploadDocument(event,type) {
      let data = new FormData();
      let file = event[0];
      // data.append("name", "my-file");
      data.append("file", file);
      this.loading = true;

      OnBoardingService.uploadAttachments(data)
        .then(resp => {
          if (resp) {
            this.loading = false;
            if(type=='tan'){
            this.statForm.tanDocId = resp.UniqueID;
            this.statForm.tanSiteUrl = resp.SiteUrl;
            } if(type=='vat'){
            this.statForm.vatDocId = resp.UniqueID;
            this.statForm.vatSiteUrl = resp.SiteUrl;
            } if(type=='msme'){
            this.statForm.msmeDocId = resp.UniqueID;
            this.statForm.msmeSiteUrl = resp.SiteUrl;
            } if(type=='aadhar'){
            this.statForm.aadharDocId = resp.UniqueID;
            this.statForm.aadharSiteUrl = resp.SiteUrl;
            } 
          }
        })
        .catch(error => {
          this.triggerModal = true;
          this.loading = false;
          this.triggerModal = true;
          this.lastResponse = " Try After Sometime";
          this.alertsuccess = true;
        });
    },    
    isNumber(event, message) {
      if (!/\d/.test(event.key))   
        return event.preventDefault();  
    },
    showAttachFile(event) {
      this.loading = true;
      OnBoardingService.downLoadDocument(event)
        .then(res => {
          this.loading = false;
        })
        .catch(e => {
                window.alert("Something went wrong! try again later");
          this.loading = false;
        });
    },
    getFileName(fileName) {
      var fileNameFinal = "";
      fileNameFinal = fileName ? fileName.split(/_(.+)/)[1] : '';
      return fileNameFinal;
    },
    mobileValidationObj(){
      if(!this.$root.isInternational){
        return {required: true, regex_mobile_number: true, length: this.phoneNumberLength}
      } else {
        return {required: true, min:6}
      }     
    },
    getContactCategoryDropdown() {
      let dropdownValues = [
        { value: "P", text: "Primary" },
        { value: "S", text: "Secondary" }
      ];
      this.contactCategories = dropdownValues;
    },
    getPartnerInfo() {
      partnerService.getPartnerInfo().then(resp => {
        this.companycode = resp.response.currentCompanyCode;
        this.statForm.companyCode = resp.response.currentCompanyCode;
        this.$root.isInternational =
              resp.response.countryDetail.countryCode == 100 ? false : true;
      });
    },
    closeContactModal(event) {
      // this.emptyContact();
      //   console.log(this.contact);
      this.$emit("eventClose", event);
    },
    isFormValid(){
      if(!this.$root.isInternational){
        if(this.isTAN=='Y' && !this.isTANPresent){
          if(!this.statForm.tan || this.statForm.tan.trim()=='' || !this.statForm.tanDocId){
            window.alert("Please fill TAN details and document to proceed.")
            return false;
          } 
        } else {
          if(!this.statForm.tanDocId && !this.isTANPresent){
            window.alert("Please fill TAN details and document to proceed.")
            return false;
          } 
        }
         if(this.isAadharApplicable && this.isAadhar=='Y' && !this.isAadharPresent){
          if(!this.statForm.aadhar || this.statForm.aadhar.trim()=='' || !this.statForm.aadharDocId){
            window.alert("Please fill aadhar details and document to proceed.")
            return false;
          }
         }
         if(this.isAadharApplicable && this.isAadhar=='N' && !this.isAadharPresent){
          if(!this.statForm.aadharDocId){
            window.alert("Please fill aadhar details and document to proceed.")
            return false;
          }
         }
         if(this.isMSME=='Y' && !this.isMSMEPresent){
          if(!this.statForm.msmeNumber || !this.statForm.msmeType 
          || !this.statForm.msmeEffectiveFrom || this.statForm.msmeNumber.trim()=='' 
          || !this.statForm.msmeClassificationYear || !this.statForm.msmeDocId){
            window.alert("Please fill MSME details and document proceed.")
            return false;
          } 
        }
      }
      if (this.$root.isInternational && this.isVAT=='Y' && !this.isVATPresent) {
        if(!this.statForm.vatRegNumber || this.statForm.vatRegNumber.trim()=='' || !this.statForm.vatDocId){
          window.alert("Please fill VAT details and document to proceed.")
          return false;
        } 
      }
      if (this.$root.isInternational && this.isVAT=='N' && !this.isVATPresent) {
        if(!this.statForm.vatDocId){
          window.alert("Please fill VAT details and document to proceed.")
          return false;
        } 
      }
      return true
    },
    saveStatutory(isEdit) {
      this.loading = true;
      var isValidForm = this.isFormValid()
      if (isValidForm) {
        partnerService
          .statutoryQL(this.statForm)
          .then(res => {
            if (res.response) {
              this.loading = false;
              this.$emit("afterSave");
              this.isEdit = false;
            }
            if (res.failureMessage) {
              //this.$emit("alertOnSave", res.failureMessage); 
                window.alert(res.failureMessage);
              this.loading = false;
            }
          })
          .catch(e => {
                window.alert("Something went wrong! try again later");
            this.loading = false;
          });
      } else {this.loading = false;
           //window.alert('Form incomplete!. Please ensure all fields are valid and attachment is uploaded!')
      }
    }
  }
};
</script>
<style scoped>
.disabled-field{  
  cursor: none;
    pointer-events: none;
    opacity: 0.5;
    user-select: none;
}
.empanel-modal-close {
  padding: 8px !important;
  background-image: linear-gradient(to bottom, #1d76ae, #055396);
  border: 0.1px;
}
.empanel-modal-close {
  padding: 8px !important;
  background-image: linear-gradient(to bottom, #1d76ae, #055396);
  border: 0.1px;
}
.empanel-modal-close {
  padding: 8px !important;
  background-image: linear-gradient(to bottom, #1d76ae, #055396);
  border: 0.1px;
}
.field-hd {
  padding-bottom:3px;
}
.button-class {
  width: 100px;
  height: 30px;
  font-family: "Source Sans Pro", sans-serif;
  font-size: 14px;
  color: white !important;
  border-radius: 2px;
  background-color: #1579ab;
  margin-bottom: 30px;
  display: block;
  margin-left: auto !important;
  margin-right: auto !important;
}
.button-class:disabled {
  color: white !important;
}
</style>